export default "__VITE_ASSET__BbRr4C9n__"